import { useCallback } from 'react';

const SMALLS = [
  'zero',
  'one',
  'two',
  'three',
  'four',
  'five',
  'six',
  'seven',
  'eight',
  'nine',
  'ten',
  'eleven',
  'twelve',
  'thirteen',
  'fourteen',
  'fifteen',
  'sixteen',
  'seventeen',
  'eighteen',
  'nineteen',
];
const TENS = [
  '',
  '',
  'twenty',
  'thirty',
  'forty',
  'fifty',
  'sixty',
  'seventy',
  'eighty',
  'ninety',
];

/**
 * React hook that returns a memoised function for converting
 * integers 0 – 100 into English words.
 *
 * Usage:
 *   const numberToWords = useNumberToWords();
 *   const word = numberToWords(42); // => "forty two"
 */
const useNumberToWords = () => {
  /**
   * Converts a number to words.
   * - Handles 0 – 100 inclusive.
   * - Falls back to String(num) for out-of-range or invalid input.
   */
  const toWords = useCallback((num) => {
    const n = Number(num);

    if (!Number.isFinite(n) || n < 0 || n > 100 || Math.floor(n) !== n) {
      return String(num);
    }

    if (n < 20) return SMALLS[n];
    if (n === 100) return 'one hundred';

    const tens = Math.floor(n / 10);
    const ones = n % 10;
    return ones === 0 ? TENS[tens] : `${TENS[tens]}-${SMALLS[ones]}`;
  }, []);

  return { toWords };
};

export default useNumberToWords;
